module.exports = __webpack_public_path__ + "static/media/Mobile Screen.4c11d52b.png";